/* ndl-wishlist.js — replaces the Swish (Wishlist King) app.
 *
 * Stores the shopper's shortlist in localStorage. No account, no server, no
 * monthly fee — which is what feedback_shopify_native_infra requires (no hosted
 * backend for customer-facing features).
 *
 * KNOWN AND ACCEPTED LIMITATION: the list lives in ONE browser. Shortlist on a
 * phone and it is not on the laptop; clear site data and it is gone. Syncing
 * across devices needs customer-metafield writes, which needs Admin API, which
 * needs a server — a directive decision, not a coding one. See
 * docs/proposals/replace-apps-2026-08-16/ §E.
 *
 * Stores HANDLES, not numeric IDs: handles survive a re-import, and /products/
 * {handle}.js gives us live price and image without duplicating product data
 * into storage that would go stale.
 */
(function () {
  'use strict';
  var KEY = 'ndl_wishlist_v1';
  var MAX = 200;                      // a shortlist, not a second catalogue

  function read() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(v) ? v.filter(function (h) { return typeof h === 'string'; }) : [];
    } catch (e) {
      return [];                      // corrupt or storage blocked (private mode)
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX)));
      return true;
    } catch (e) {
      return false;                   // quota or private mode — fail quiet, never throw
    }
  }

  var NDLWishlist = {
    all: read,
    has: function (handle) { return read().indexOf(handle) !== -1; },
    count: function () { return read().length; },

    toggle: function (handle) {
      var list = read();
      var i = list.indexOf(handle);
      if (i === -1) { list.unshift(handle); } else { list.splice(i, 1); }
      write(list);
      document.dispatchEvent(new CustomEvent('ndl:wishlist:change', {
        detail: { handle: handle, added: i === -1, count: list.length }
      }));
      return i === -1;
    },

    remove: function (handle) {
      var list = read().filter(function (h) { return h !== handle; });
      write(list);
      document.dispatchEvent(new CustomEvent('ndl:wishlist:change',
        { detail: { handle: handle, added: false, count: list.length } }));
    }
  };
  window.NDLWishlist = NDLWishlist;

  /* --- heart buttons ------------------------------------------------------ */
  function paint(btn) {
    var on = NDLWishlist.has(btn.getAttribute('data-handle'));
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    btn.classList.toggle('is-saved', on);
    btn.setAttribute('aria-label', on ? 'Remove from wishlist' : 'Save to wishlist');
  }

  function paintAll() {
    document.querySelectorAll('[data-ndl-wishlist-toggle]').forEach(paint);
    document.querySelectorAll('[data-ndl-wishlist-count]').forEach(function (el) {
      var n = NDLWishlist.count();
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  // Delegated: collection grids lazy-load and paginate, so binding per-button
  // at load would miss every tile added afterwards.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-ndl-wishlist-toggle]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();              // tiles are wrapped in a link to the PDP
    NDLWishlist.toggle(btn.getAttribute('data-handle'));
    paint(btn);
  });

  document.addEventListener('ndl:wishlist:change', paintAll);
  document.addEventListener('DOMContentLoaded', paintAll);
  if (document.readyState !== 'loading') paintAll();

  /* --- wishlist page ------------------------------------------------------ */
  function money(cents, fmt) {
    var v = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return (fmt || '₹{{amount}}').replace(/\{\{\s*amount\s*\}\}/, v);
  }

  window.NDLWishlistRender = function (root) {
    var list = NDLWishlist.all();
    var empty = root.querySelector('[data-ndl-empty]');
    var grid = root.querySelector('[data-ndl-grid]');
    if (!grid) return;
    grid.innerHTML = '';
    if (!list.length) { if (empty) empty.hidden = false; return; }
    if (empty) empty.hidden = true;

    // Fetch each product live rather than caching price/image in localStorage,
    // where they would silently go stale after a price change.
    Promise.all(list.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (items) {
      var gone = [];
      items.forEach(function (p, i) {
        if (!p) { gone.push(list[i]); return; }   // unpublished or renamed
        var img = (p.featured_image || '').replace(/^\/\//, 'https://');
        var el = document.createElement('div');
        el.className = 'ndl-wl__card';
        el.innerHTML =
          '<a href="/products/' + p.handle + '">' +
            (img ? '<img src="' + img + '&width=500" alt="" loading="lazy">' : '') +
            '<span class="ndl-wl__title"></span>' +
          '</a>' +
          '<span class="ndl-wl__price"></span>' +
          '<button type="button" class="ndl-wl__remove" data-handle="' + p.handle + '">Remove</button>';
        el.querySelector('.ndl-wl__title').textContent = p.title;   // textContent, never innerHTML
        el.querySelector('.ndl-wl__price').textContent =
          money(p.price, root.getAttribute('data-money-format'));
        grid.appendChild(el);
      });
      // A product that 404s was deleted or unpublished. Drop it silently rather
      // than leaving a permanently broken tile the shopper cannot clear.
      if (gone.length) { gone.forEach(NDLWishlist.remove); }
      if (!grid.children.length && empty) empty.hidden = false;
    });

    grid.addEventListener('click', function (e) {
      var b = e.target.closest('.ndl-wl__remove');
      if (!b) return;
      NDLWishlist.remove(b.getAttribute('data-handle'));
      window.NDLWishlistRender(root);
    });
  };
})();
